import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import Header from './Header';

import axios from 'axios';
import { projects } from '../utils/data';
import { verify, view, remove } from '../utils/auth';

export default function Landing() {
  const navigate = useNavigate();
  const [url, setUrl] = useState('');
  const [text, setText] = useState('Search');
  const [isLoading, setIsLoading] = useState(false);
  const [projectDetails, setProjectDetails] = useState({});

  const [viewModal, setViewModal] = useState(false);

  const handleProjectView = (id) => {
    const _project = projects.find((project) => project.id === id);
    setProjectDetails(Object.keys(_project).length > 0 ? _project : {});
  };

  return (
    <>
      <Header />
      {/* <!--  start page loader  --> */}
      <div id='preloader'>
        <div class='scroll-static'></div>
      </div>
      {/* <!--  end page loader  --> */}

      {/* <!-- start landing wrapper  --> */}
      <div
        className='landing_wrapper bg-img'
        style={{
          backgroundImage: `url("/img/bg.jpg")`,
          backgroundSize: 'cover',
          height: '70vh',
        }}
      >
        {/* <!-- start home wrapper --> */}
        <div class='home_wrapper'>
          {/* <!-- start landing content --> */}
          <div class='absolute landing_content'>
            <div class='container'>
              <div
                class='row align-items-center'
                style={{ paddingTop: '-10px !important' }}
              >
                <div class='col-12'>
                  <h5 class=''>Hi There, I'm</h5>
                  <h1 class=''>Emmanuel</h1>
                  <h4 class=''>Software Engineer</h4>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- end landing content --> */}
        </div>
        {/* <!-- end home wrapper --> */}
      </div>
      {/* <!-- end landing wrapper  --> */}
      <div class='container'>
        <div class='row'>
          <div class='col'>
            {/* <!-- start about wrapper --> */}
            <div id='about' class='about_wrapper'>
              <div class='about'>
                <div class='row justify-content-center align-items-center'>
                  <div class='col-lg-4 col-md-5'>
                    {/* <!-- start about image --> */}
                    <div class='about_img'>
                      <img
                        class='about_img_1 top'
                        src='/img/pic.jpeg'
                        style={{
                          height: '25em',
                          width: '100%',
                          objectFit: 'cover',
                        }}
                        alt=''
                      />
                      <img
                        class='about_img_2 bottom'
                        src='/img/about_photo_2.jpg'
                        alt=''
                      />
                    </div>
                    {/* <!-- end about image --> */}
                  </div>
                  <div class='col-lg-6 col-md-7'>
                    {/* <!-- start about details --> */}
                    <div class='about_info'>
                      <h4>Why you should hire me?</h4>
                      <img class='zigzag' src='/img/zigzag.svg' alt='' />
                      <p class='about_desc'>
                        <span>
                          I am a software engineer from Lagos, Nigeria.
                        </span>{' '}
                        <br />
                        With over 5 years of experience in the field of
                        programming, I can build you a solution-providing
                        application/software for your business. I code with
                        Javascript, Typescript - Node.js, React.js, Next.js
                        Express.js, Nest.js.
                      </p>
                      {/* <!-- start social links --> */}
                      <ul class='social_links hidden'>
                        {/* Twitter */}
                        <li>
                          <a
                            href='https://twitter.com/manuelextra_'
                            class='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              class='bi bi-twitter'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z' />{' '}
                            </svg>
                          </a>
                        </li>
                        {/* Instagram */}
                        <li>
                          <a
                            href='https://instagram.com/manuelextra_'
                            class='text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800'
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              class='bi bi-instagram'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z' />{' '}
                            </svg>
                          </a>
                        </li>
                        {/* LinkedIn */}
                        <li>
                          <a
                            href='https://linkedin.com/in/manuelextra'
                            class='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              class='bi bi-linkedin'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z' />{' '}
                            </svg>
                          </a>
                        </li>
                        {/* Facebook */}
                        <li>
                          <a
                            href='https://facebook.com/manuelExtra'
                            class='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              class='bi bi-facebook'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z' />{' '}
                            </svg>
                          </a>
                        </li>
                        {/* Whatsapp */}
                        <li>
                          <a
                            href='/wa.me/+2348129027941'
                            class='text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800'
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              class='bi bi-whatsapp'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z' />{' '}
                            </svg>
                          </a>
                        </li>
                      </ul>

                      {/* <!-- end social links --> */}
                    </div>
                    <div className='mt-4'>
                      <a
                        href='/doc/resume.pdf'
                        target='_blank'
                        className='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800'
                      >
                        View Resume
                      </a>
                    </div>
                    {/* <!-- end about details --> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- end about wrapper -->
                <!-- start services wrapper --> */}
            <div id='service' class='services'>
              <div class='row justify-content-center'>
                <div class='col-lg-10'>
                  {/* <!-- section title --> */}
                  <div class='text-center'>
                    <h2 class='section_title'>Services</h2>
                  </div>
                  {/* <!-- start service items --> */}
                  <div class='service_items'>
                    <div class='row'>
                      {/* <!-- start service single items --> */}
                      <div class='col-lg-4 col-md-6 col-sm-6'>
                        <div class='service_single_item'>
                          <div className='mb-3'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='30'
                              height='30'
                              fill='currentColor'
                              class='bi bi-code-slash'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z' />{' '}
                            </svg>
                          </div>
                          <h6 data-hover='Static websites'>Static websites</h6>
                          <p>Customized web pages that would suit you best.</p>
                        </div>
                      </div>
                      {/* <!-- end service single items -->
                                    <!-- start service single items --> */}
                      <div class='col-lg-4 col-md-6 col-sm-6'>
                        <div class='service_single_item'>
                          <div className='mb-3'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              class='icon icon-tabler icon-tabler-code-plus'
                              width='30'
                              height='30'
                              viewBox='0 0 24 24'
                              stroke-width='2'
                              stroke='currentColor'
                              fill='none'
                              stroke-linecap='round'
                              stroke-linejoin='round'
                            >
                              {' '}
                              <path
                                stroke='none'
                                d='M0 0h24v24H0z'
                                fill='none'
                              />{' '}
                              <path d='M9 12h6' /> <path d='M12 9v6' />{' '}
                              <path d='M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2' />{' '}
                              <path d='M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2' />{' '}
                            </svg>
                          </div>
                          <h6 data-hover='Functional web'>Functional app</h6>
                          <p>
                            Amazing features that you would love your app to
                            have.
                          </p>
                        </div>
                      </div>
                      {/* <!-- end service single items -->
                                    <!-- start service single items --> */}
                      <div class='col-lg-4 col-md-6 col-sm-6'>
                        <div class='service_single_item'>
                          <div className='mb-3'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              class='icon icon-tabler icon-tabler-message-2-code'
                              width='30'
                              height='30'
                              viewBox='0 0 24 24'
                              stroke-width='2'
                              stroke='currentColor'
                              fill='none'
                              stroke-linecap='round'
                              stroke-linejoin='round'
                            >
                              {' '}
                              <path
                                stroke='none'
                                d='M0 0h24v24H0z'
                                fill='none'
                              />{' '}
                              <path d='M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3' />{' '}
                              <path d='M10 9l-2 2l2 2' />{' '}
                              <path d='M14 9l2 2l-2 2' />{' '}
                            </svg>
                          </div>
                          <h6 data-hover='Large-Scale Web'>Large-Scale App</h6>
                          <p>
                            Advanced features and decision-making algorithms for
                            your solution.
                          </p>
                        </div>
                      </div>
                      {/* <!-- end service single items -->
                                    <!-- start service single items --> */}
                      <div class='col-lg-4 col-md-6 col-sm-6'>
                        <div class='service_single_item'>
                          <div className='mb-3'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='30'
                              height='30'
                              fill='currentColor'
                              class='bi bi-flag'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21.294 21.294 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21.317 21.317 0 0 0 14 7.655V1.222z' />{' '}
                            </svg>
                          </div>
                          <h6 data-hover='Branding'>Branding</h6>
                          <p>
                            A complete distinguishing feel for attracting
                            potential clients.
                          </p>
                        </div>
                      </div>
                      {/* <!-- end service single items -->
                                    <!-- start service single items --> */}
                      <div class='col-lg-4 col-md-6 col-sm-6'>
                        <div class='service_single_item'>
                          <div className='mb-3'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='30'
                              height='30'
                              fill='currentColor'
                              class='bi bi-people-fill'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z' />{' '}
                              <path
                                fill-rule='evenodd'
                                d='M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z'
                              />{' '}
                              <path d='M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z' />{' '}
                            </svg>
                          </div>
                          <h6 data-hover='Support'>Support</h6>
                          <p>
                            Swift client support to resolve issues that may
                            arise.
                          </p>
                        </div>
                      </div>
                      {/* <!-- end service single items -->
                                    <!-- start service single items --> */}
                      <div class='col-lg-4 col-md-6 col-sm-6'>
                        <div class='service_single_item'>
                          <div className='mb-3'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='30'
                              height='30'
                              fill='currentColor'
                              class='bi bi-hdd-stack-fill'
                              viewBox='0 0 16 16'
                            >
                              {' '}
                              <path d='M2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z' />{' '}
                            </svg>
                          </div>
                          <h6 data-hover='Maintenance'>Maintenance</h6>
                          <p>
                            Web maintenance services and version control
                            systems.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- end service items --> */}
                </div>
              </div>
            </div>
            {/* <!-- end services wrapper --> */}
            {/* <!-- start work wrapper --> */}
            <div id='works' class='work_wrapper'>
              <div class='row justify-content-center'>
                <div class='col-lg-10'>
                  {/* <!-- section title --> */}
                  <div class='text-center'>
                    <h2 class='section_title'>Recent Works</h2>
                  </div>

                  {/* <!-- work filter start --> */}
                  {/* <div class="row no-gutters">
                    <div class="col-12">
                      <div class="filter-buttons">
                        <button class="active" data-filter="*">
                          Everything
                        </button>
                        <button data-filter=".web">Web</button>
                        <button data-filter=".uiux">UI/UX</button>
                        <button data-filter=".branding">Branding</button>
                      </div>
                    </div>
                  </div> */}
                  {/* <!-- work filter end --> */}

                  <div class='row works'>
                    {/* <!-- work single item  --> */}
                    {projects.map((project) => (
                      <div class='col-lg-4 col-md-6 col-sm-6 uiux'>
                        <div class='work_single_item'>
                          <img
                            class='img-fluid'
                            src={project.project[0]}
                            alt=''
                          />
                          <div class='work_info'>
                            <h6 title={project.name}>{project.name}</h6>
                            <p>{project.dateCompleted}</p>

                            <a
                              data-modal-target='extralarge-modal'
                              data-modal-toggle='extralarge-modal'
                              class='ajax-popup-link text-center'
                              onClick={() => handleProjectView(project.id)}
                              href='javascript:void(0)'
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='18'
                                height='18'
                                fill='currentColor'
                                class='bi bi-arrows-fullscreen m-3 font-black'
                                viewBox='0 0 16 16'
                              >
                                {' '}
                                <path
                                  fill-rule='evenodd'
                                  d='M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z'
                                />{' '}
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* <!-- view all work button  --> */}
                    {/* <div class="col-lg-12">
                      <a
                        class="button slide-vertical"
                        data-splitting
                        href="all-works.html"
                      >
                        View All Works
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- end work wrapper -->
                <!-- start counter wrapper --> */}
            <div class='counter'>
              <div class='row justify-content-center text-center'>
                <div class='col-lg-10'>
                  <div class='row'>
                    <div class='col-4 col-sm-4 col-md-4'>
                      <i className='pl-4 pt-2'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='24'
                          height='24'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          stroke-width='2'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                          class='feather feather-users'
                        >
                          <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'></path>
                          <circle cx='9' cy='7' r='4'></circle>
                          <path d='M23 21v-2a4 4 0 0 0-3-3.87'></path>
                          <path d='M16 3.13a4 4 0 0 1 0 7.75'></path>
                        </svg>
                      </i>
                      <h4>Happy Clients</h4>
                      <span class='counter-number'>2</span>
                    </div>
                    <div class='col-4 col-sm-4 col-md-4'>
                      <i class='pl-4 pt-2'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='30'
                          height='30'
                          fill='currentColor'
                          class='bi bi-code-slash'
                          viewBox='0 0 16 16'
                        >
                          {' '}
                          <path d='M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z' />{' '}
                        </svg>
                      </i>
                      <h4>Project Done</h4>
                      <span class='counter-number'>2</span>
                    </div>
                    {/* <div class="col-6 col-sm-6 col-md-3">
                      <i class="mbri-hot-cup"></i>
                      <h4>Coffee Cups</h4>
                      <span class="counter-number">2652</span>
                    </div> */}
                    <div class='col-4 col-sm-4 col-md-4'>
                      <i class='pl-4 pt-2'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 256 256'
                        >
                          <rect width='256' height='256' fill='none' />
                          <path
                            d='M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z'
                            fill='none'
                            stroke='#fff'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                            stroke-width='24'
                          />
                          <line
                            x1='96'
                            y1='108'
                            x2='160'
                            y2='108'
                            fill='none'
                            stroke='#fff'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                            stroke-width='24'
                          />
                          <line
                            x1='96'
                            y1='148'
                            x2='160'
                            y2='148'
                            fill='none'
                            stroke='#fff'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                            stroke-width='24'
                          />
                        </svg>
                      </i>
                      <h4>Total Review</h4>
                      <span class='counter-number'>2</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- end counter wrapper -->
                <!-- start testimonials wrapper --> */}
            <div id='testimonial' class='testimonials'>
              <div class='row justify-content-center'>
                <div class='col-md-8'>
                  {/* <!-- section title --> */}
                  <div class='text-center'>
                    <h2 class='section_title'>Testimonials</h2>
                  </div>
                  {/* <div class="owl-carousel testimonial_slider"> */}

                  <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    items={1}
                    autoplay={true}
                    autoplayTimeout={5000}
                    autoplayHoverPause={true}
                  >
                    {/* <!-- start testimonial single item --> */}
                    <div class='testimonial_single_item'>
                      <img
                        src='/img/testimonials/akinode1_1573291495.jpeg'
                        alt='photo'
                      />
                      <p>
                        Lorem ipsum dolor sit amet omnis consectetur adipisicing
                        elit empora quia forem ipsum dolorsiempora aspernatur
                        dolore, sapiente quidem sequi non tenetur harum, nihil
                        quis beatae rerum ipsa nemo quae voluptate, repellendus
                        nostrum debitis velit nisi.
                      </p>
                      <h4>Mr Akinode J.L</h4>
                      <span>Lecturer - Federal Poly Ilaro.</span>
                    </div>
                    {/* <!-- end testimonial single item -->
                                <!-- start testimonial single item --> */}
                    <div class='testimonial_single_item'>
                      <img src='/img/testimonials/mrs-helen.jpeg' alt='photo' />
                      <p>
                        Lorem ipsum dolor sit amet omnis consectetur adipisicing
                        elit empora quia forem ipsum dolorsiempora aspernatur
                        dolore, sapiente quidem sequi non tenetur harum, nihil
                        quis beatae rerum ipsa nemo quae voluptate, repellendus
                        nostrum debitis velit nisi.
                      </p>
                      <h4>Mrs Helen</h4>
                      <span>CEO - Freshfruitcreamery.</span>
                    </div>
                    {/* <!-- end testimonial single item -->
                                <!-- start testimonial single item --> */}
                    {/* <div class="testimonial_single_item">
                      <img src="/img/testimonials/test_03.jpg" alt="photo" />
                      <p>
                        Lorem ipsum dolor sit amet omnis consectetur adipisicing
                        elit empora quia forem ipsum dolorsiempora aspernatur
                        dolore, sapiente quidem sequi non tenetur harum, nihil
                        quis beatae rerum ipsa nemo quae voluptate, repellendus
                        nostrum debitis velit nisi.
                      </p>
                      <h4>John Dio</h4>
                      <span>Founder - Alada Inc.</span>
                    </div> */}
                    {/* <!-- end testimonial single item --> */}
                  </OwlCarousel>
                  {/* </div> */}
                </div>
              </div>
            </div>
            {/* <!-- end testimonials wrapper -->
                <!-- start clients wrapper --> */}
            <div class='clients'>
              <div class='row justify-content-center text-center'>
                <div class='col-lg-10 client_items'>
                  {/* <!-- section title --> */}
                  <h2 class='section_title'>Clients</h2>
                  {/* <div class="row flex">
                    <div class="col flex">
                      <img src="/img/brand/brand_01.png" alt="Brand_01" />
                      <img src="/img/brand/brand_02.png" alt="Brand_02" />
                      <img src="/img/brand/brand_03.png" alt="Brand_03" />
                      <img src="/img/brand/brand_04.png" alt="Brand_04" />
                      <img src="/img/brand/brand_05.png" alt="Brand_05" />
                      <img src="/img/brand/brand_06.png" alt="Brand_06" />
                      <img src="/img/brand/brand_07.png" alt="Brand_07" />
                    </div>
                  </div> */}
                  <div className='grid grid-cols-2 justify-center justify-items-center gap-4 m-auto'>
                    <img
                      src='/img/fpi.png'
                      alt='Brand_01'
                      style={{
                        width: '10em',
                        height: '5em',
                        objectFit: 'contain',
                      }}
                    />
                    <img
                      src='/img/freshfruit.png'
                      alt='Brand_02'
                      style={{
                        width: '10em',
                        height: '5em',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- end clients wrapper -->
                <!-- start contact wrapper --> */}
            <div id='contact' class='contact_wrapper'>
              <div class='text-center'>
                <h2 class='section_title'>Drop a line</h2>
              </div>
              <div class='row justify-content-center'>
                {/* <!-- start contact info ( email - phone) --> */}
                <div class='col-lg-3 col-md-12'>
                  <div class='contact_item'>
                    <h5>Phone</h5>
                    <p>+234-812-9027-941</p>
                  </div>
                  <div class='contact_item'>
                    <h5>Email</h5>
                    <p>olaleyeemmanuel23@gmail.com</p>
                  </div>
                </div>
                {/* <!-- end contact info ( email - phone) -->
                        <!-- start contact form --> */}
                <div class='col-lg-7 col-md-12'>
                  <form
                    id='contact-form'
                    action='https://ixtheme.netlify.app/zuman/php/mail.php'
                  >
                    <div class='row'>
                      <div class='col'>
                        <p class='form-message'></p>
                      </div>
                    </div>
                    <div class='row'>
                      <div class='col-md-5'>
                        {/* <!-- input field for NAME --> */}
                        <input
                          class='input_field required'
                          type='text'
                          name='name'
                          style={{ background: 'none' }}
                          placeholder='Name'
                        />
                        {/* <!-- input field for EMAIL --> */}
                        <input
                          class='input_field required'
                          type='email'
                          name='email'
                          style={{ background: 'none' }}
                          placeholder='Email'
                        />
                      </div>
                      <div class='col-md-7'>
                        {/* <!-- input field for MESSAGE --> */}
                        <textarea
                          class='input_field required'
                          name='message'
                          placeholder='Tell Me About Your Query.'
                        ></textarea>
                      </div>
                    </div>
                    <div class='row'>
                      <div class='col-md-12 text-center'>
                        {/* <!-- button for MESSAGE-SEND --> */}
                        <button
                          class='button slide-vertical pb-2'
                          type='submit'
                        >
                          send message
                        </button>
                        {/* <button type="button" class="text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700">Light</button> */}
                      </div>
                      <div class='col-12'>
                        <br />
                        <small>
                          <b>NOTE:</b> Don't worry about showing any contact
                          form error in demo version,
                          <br /> it works properly in downloadable version.
                        </small>
                      </div>
                    </div>
                  </form>
                </div>
                {/* <!-- end contact form --> */}
              </div>
            </div>
            {/* <!-- end contact wrapper -->
                <!-- start footer wrapper --> */}
            <footer>
              <a href='#top' class='go_top'>
                {/* <i class="ion-ios-arrow-thin-up"></i> */}
                <svg
                  // style={{ color: "white" }}
                  xmlns='http://www.w3.org/2000/svg'
                  width='53'
                  height='60'
                  fill='currentColor'
                  class='bi bi-arrow-up pt-3'
                  viewBox='0 0 16 16'
                >
                  {' '}
                  <path
                    fill-rule='evenodd'
                    d='M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z'
                    fill='white'
                  ></path>{' '}
                </svg>
              </a>
              {/* <!-- start social links --> */}
              <ul class='social_links'>
                {/* Twitter */}
                <li>
                  <a
                    href='/'
                    class='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      class='bi bi-twitter'
                      viewBox='0 0 16 16'
                    >
                      {' '}
                      <path d='M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z' />{' '}
                    </svg>
                  </a>
                </li>
                {/* Instagram */}
                <li>
                  <a
                    href='/'
                    class='text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      class='bi bi-instagram'
                      viewBox='0 0 16 16'
                    >
                      {' '}
                      <path d='M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z' />{' '}
                    </svg>
                  </a>
                </li>
                {/* LinkedIn */}
                <li>
                  <a
                    href='/'
                    class='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      class='bi bi-linkedin'
                      viewBox='0 0 16 16'
                    >
                      {' '}
                      <path d='M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z' />{' '}
                    </svg>
                  </a>
                </li>
                {/* Facebook */}
                <li>
                  <a
                    href='/'
                    class='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      class='bi bi-facebook'
                      viewBox='0 0 16 16'
                    >
                      {' '}
                      <path d='M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z' />{' '}
                    </svg>
                  </a>
                </li>
                {/* Whatsapp */}
                <li>
                  <a
                    href='/'
                    class='text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center mr-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      class='bi bi-whatsapp'
                      viewBox='0 0 16 16'
                    >
                      {' '}
                      <path d='M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z' />{' '}
                    </svg>
                  </a>
                </li>
              </ul>
              <p class='copyright'>
                &copy; <span>ManuelExtra Technologies</span>. All Rights
                Reserved.
              </p>
            </footer>
            {/* <!-- end footer wrapper --> */}
          </div>
        </div>
      </div>

      {/* <!-- Modal toggle --> */}

      {/* <!-- Extra Large Modal --> */}
      <div
        id='extralarge-modal'
        tabindex='-1'
        class='fixed left-0 z-50 top-0 bottom-0 right-0 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full'
      >
        <div class='relative md:top-40 bottom-0 w-full h-full max-w-7xl md:h-auto pb-5'>
          {/* <!-- Modal content --> */}
          <div class='relative mt-3 pb-3 md:top-20 bottom-10 bg-gray-900 rounded-lg shadow dark:bg-gray-700'>
            {/* <!-- Modal header --> */}
            <div class='flex justify-end'>
              <button
                type='button'
                class='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-white rounded-lg text-sm p-1.5 text-left inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white'
                data-modal-hide='extralarge-modal'
              >
                <svg
                  aria-hidden='true'
                  class='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 20 20'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                    clip-rule='evenodd'
                  ></path>
                </svg>
                <span class='sr-only'>Close modal</span>
              </button>
            </div>

            {Object.keys(projectDetails).length > 0 ? (
              <div class='container'>
                <div class='row justify-content-center text-center'>
                  <div class='col-md-8 mb-5'>
                    <div class=''>
                      <h3 class='font-bold' style={{ fontSize: '2em' }}>
                        {projectDetails.name}
                      </h3>
                      <p>{projectDetails.short}</p>
                    </div>
                  </div>
                </div>
                <div class='row justify-content-center text-center'>
                  <div class='col-md-3'>
                    <div class='work-info-card'>
                      <h6>Client</h6>
                      <p>{projectDetails.client}</p>
                    </div>
                  </div>
                  <div class='col-md-3'>
                    <div class='work-info-card'>
                      <h6>Link</h6>
                      <p>
                        <a
                          className='flex'
                          href={projectDetails.link}
                          target='_blank'
                        >
                          🔗 <span>View Project</span>
                        </a>
                      </p>
                    </div>
                  </div>
                  <div class='col-md-3'>
                    <div class='work-info-card'>
                      <h6>Date</h6>
                      <p>{projectDetails.dateCompleted}</p>
                    </div>
                  </div>
                </div>
                <div class='row justify-content-center text-center'>
                  <div class='col-md-12'>
                    <div class='work-image'>
                      {/* <img
                        class="img-fluid"
                        src={projectDetails.project[0]}
                        alt=""
                        style={{width: '100px'}}
                      /> */}
                      <iframe
                        src={projectDetails.link}
                        style={{ width: '100%', height: '50em' }}
                      ></iframe>
                    </div>
                  </div>
                  <div class='col-md-8'>
                    <div class='work-details'>
                      <h4>About Project</h4>
                      <p>{projectDetails.about}</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </>
  );
}
